module.exports = __webpack_public_path__ + "static/media/communities-orange-icon.e17799f9.jpg";